import { render, staticRenderFns } from "./fiscal.vue?vue&type=template&id=4fa361ba&scoped=true&"
import script from "./fiscal.vue?vue&type=script&lang=js&"
export * from "./fiscal.vue?vue&type=script&lang=js&"
import style0 from "./fiscal.vue?vue&type=style&index=0&id=4fa361ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa361ba",
  null
  
)

export default component.exports